"use client";

import { motion } from "framer-motion";
import { ReactNode } from "react";

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  initial?: any;
  animate?: any;
  whileInView?: any;
  viewport?: any;
  transition?: any;
  id?: string;
}

export function AnimatedSection({ 
  children, 
  className, 
  initial, 
  animate, 
  whileInView, 
  viewport, 
  transition,
  id 
}: AnimatedSectionProps) {
  return (
    <motion.section
      id={id}
      className={className}
      initial={initial}
      animate={animate}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
    >
      {children}
    </motion.section>
  );
}

interface AnimatedDivProps {
  children: ReactNode;
  className?: string;
  initial?: any;
  animate?: any;
  whileInView?: any;
  viewport?: any;
  transition?: any;
  whileHover?: any;
}

export function AnimatedDiv({ 
  children, 
  className, 
  initial, 
  animate, 
  whileInView, 
  viewport, 
  transition,
  whileHover
}: AnimatedDivProps) {
  return (
    <motion.div
      className={className}
      initial={initial}
      animate={animate}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
      whileHover={whileHover}
    >
      {children}
    </motion.div>
  );
}

interface AnimatedH1Props {
  children: ReactNode;
  className?: string;
  initial?: any;
  animate?: any;
  transition?: any;
}

export function AnimatedH1({ 
  children, 
  className, 
  initial, 
  animate, 
  transition 
}: AnimatedH1Props) {
  return (
    <motion.h1
      className={className}
      initial={initial}
      animate={animate}
      transition={transition}
    >
      {children}
    </motion.h1>
  );
}

interface AnimatedPProps {
  children: ReactNode;
  className?: string;
  initial?: any;
  animate?: any;
  transition?: any;
}

export function AnimatedP({ 
  children, 
  className, 
  initial, 
  animate, 
  transition 
}: AnimatedPProps) {
  return (
    <motion.p
      className={className}
      initial={initial}
      animate={animate}
      transition={transition}
    >
      {children}
    </motion.p>
  );
}

interface AnimatedH2Props {
  children: ReactNode;
  className?: string;
  initial?: any;
  whileInView?: any;
  viewport?: any;
  transition?: any;
}

export function AnimatedH2({ 
  children, 
  className, 
  initial, 
  whileInView, 
  viewport, 
  transition 
}: AnimatedH2Props) {
  return (
    <motion.h2
      className={className}
      initial={initial}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
    >
      {children}
    </motion.h2>
  );
}